(function() {
  const SOLD_OUT_TEXT = '【在庫無し】次回未定';
  const SOLDOUT_BG = '#e8e8e8';
  const SOLDOUT_TEXT_COLOR = '#999';
  const INSTANT_MARKS = ['★', '☆', '●'];

  // -----------------------------------------------
  // 納期ラベル変換
  // -----------------------------------------------
  function getNoukiLabel(nouki, mark) {
    if (!nouki || nouki === SOLD_OUT_TEXT) return '';
    if (nouki.startsWith('【在庫有】')) {
      return INSTANT_MARKS.some(m => (mark || '').includes(m)) ? '【即日出荷】' : '【在庫有】';
    }
    if (nouki.startsWith('【予約】')) return '【予約】';
    return '';
  }

  // 遅い方が数値大（在庫切れ=4が最遅）
  function getNoukiPriority(nouki, mark) {
    if (!nouki || nouki === SOLD_OUT_TEXT) return 4;
    if (nouki.startsWith('【在庫有】')) {
      return INSTANT_MARKS.some(m => (mark || '').includes(m)) ? 1 : 2;
    }
    if (nouki.startsWith('【予約】')) return 3;
    return 4;
  }

  // -----------------------------------------------
  // ラジオボタン型スタイル
  // -----------------------------------------------
  function applyRadioStyles() {
    document.querySelectorAll('.variants-ui__option-value-input[data-variant-option-value]').forEach(input => {
      if (input.dataset.radioStyled) return;
      input.dataset.radioStyled = 'true';
      function renderAll() {
        const group = input.closest('.variants-ui__option-values');
        if (!group) return;
        group.querySelectorAll('.variants-ui__option-value-input[data-variant-option-value]').forEach(inp => {
          const n = inp.dataset.variantOptionCustomNouki || '';
          const vw = inp.closest('.variants-ui__option-value');
          if (!vw) return;
          const nm = vw.querySelector('.variants-ui__option-value-name');
          if (!nm) return;
          if (n === SOLD_OUT_TEXT) {
            nm.style.setProperty('background-color', SOLDOUT_BG, 'important');
            nm.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
            nm.style.setProperty('text-decoration', 'line-through', 'important');
            nm.style.setProperty('border-color', '#ccc', 'important');
          } else {
            nm.style.removeProperty('background-color');
            nm.style.removeProperty('color');
            nm.style.removeProperty('text-decoration');
            nm.style.removeProperty('border-color');
          }
        });
      }
      renderAll();
      input.addEventListener('change', renderAll);
    });
  }

  // -----------------------------------------------
  // プルダウン型バースタイル
  // -----------------------------------------------
  function setBarStyle(select, wrapper, isSoldOut) {
    if (isSoldOut) {
      if (wrapper) {
        wrapper.style.setProperty('background-color', SOLDOUT_BG, 'important');
        wrapper.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
      }
      select.style.setProperty('background-color', SOLDOUT_BG, 'important');
      select.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
    } else {
      if (wrapper) {
        wrapper.style.removeProperty('background-color');
        wrapper.style.removeProperty('color');
      }
      select.style.removeProperty('background-color');
      select.style.removeProperty('color');
    }
  }

  function updateAllSelectStyles() {
    const selects = document.querySelectorAll('select[data-variant-option]');

    if (selects.length < 2) {
      selects.forEach(select => {
        Array.from(select.options).forEach(opt => {
          if (!opt.value) return;
          const nouki = opt.getAttribute('data-nouki') || '';
          if (nouki === SOLD_OUT_TEXT) {
            opt.style.setProperty('background-color', SOLDOUT_BG, 'important');
            opt.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
          } else {
            opt.style.setProperty('background-color', '#ffffff', 'important');
            opt.style.setProperty('color', '#333333', 'important');
          }
        });
        const selectedOpt = select.options[select.selectedIndex];
        const nouki = selectedOpt && selectedOpt.value ? selectedOpt.getAttribute('data-nouki') || '' : '';
        const wrapper = select.closest('.variants-ui__input-select-wrapper');
        setBarStyle(select, wrapper, nouki === SOLD_OUT_TEXT);
      });
      return;
    }

    const select0 = selects[0];
    const select1 = selects[1];
    const opts0 = Array.from(select0.options).filter(o => o.value);
    const opts1 = Array.from(select1.options).filter(o => o.value);

    const soldOut0 = new Set(opts0.filter(o => o.getAttribute('data-nouki') === SOLD_OUT_TEXT).map(o => o.value));
    const soldOut1 = new Set(opts1.filter(o => o.getAttribute('data-nouki') === SOLD_OUT_TEXT).map(o => o.value));

    const selectedOpt0 = select0.options[select0.selectedIndex];
    const selectedOpt1 = select1.options[select1.selectedIndex];
    const selectedVal0 = selectedOpt0 && selectedOpt0.value ? selectedOpt0.value : '';
    const selectedVal1 = selectedOpt1 && selectedOpt1.value ? selectedOpt1.value : '';

    const sel1SelectedSoldOut = !!(selectedVal1 && soldOut1.has(selectedVal1));
    const sel0SelectedSoldOut = !!(selectedVal0 && soldOut0.has(selectedVal0));

    opts0.forEach(opt => {
      const shouldGray = soldOut0.has(opt.value) || sel1SelectedSoldOut;
      opt.style.setProperty('background-color', shouldGray ? SOLDOUT_BG : '#ffffff', 'important');
      opt.style.setProperty('color', shouldGray ? SOLDOUT_TEXT_COLOR : '#333333', 'important');
    });
    opts1.forEach(opt => {
      const shouldGray = soldOut1.has(opt.value) || sel0SelectedSoldOut;
      opt.style.setProperty('background-color', shouldGray ? SOLDOUT_BG : '#ffffff', 'important');
      opt.style.setProperty('color', shouldGray ? SOLDOUT_TEXT_COLOR : '#333333', 'important');
    });

    const wrapper0 = select0.closest('.variants-ui__input-select-wrapper');
    const wrapper1 = select1.closest('.variants-ui__input-select-wrapper');

    if (selectedVal0) {
      setBarStyle(select0, wrapper0, soldOut0.has(selectedVal0) || sel1SelectedSoldOut);
    } else {
      const allGray = opts0.every(o => soldOut0.has(o.value)) || sel1SelectedSoldOut;
      if (wrapper0) {
        if (allGray) {
          wrapper0.style.setProperty('background-color', SOLDOUT_BG, 'important');
          wrapper0.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
        } else {
          wrapper0.style.removeProperty('background-color');
          wrapper0.style.removeProperty('color');
        }
      }
      select0.style.removeProperty('background-color');
      select0.style.removeProperty('color');
      select0.style.setProperty('background-color', 'transparent', 'important');
    }

    if (selectedVal1) {
      setBarStyle(select1, wrapper1, soldOut1.has(selectedVal1) || sel0SelectedSoldOut);
    } else {
      const allGray = opts1.every(o => soldOut1.has(o.value)) || sel0SelectedSoldOut;
      if (wrapper1) {
        if (allGray) {
          wrapper1.style.setProperty('background-color', SOLDOUT_BG, 'important');
          wrapper1.style.setProperty('color', SOLDOUT_TEXT_COLOR, 'important');
        } else {
          wrapper1.style.removeProperty('background-color');
          wrapper1.style.removeProperty('color');
        }
      }
      select1.style.removeProperty('background-color');
      select1.style.removeProperty('color');
      select1.style.setProperty('background-color', 'transparent', 'important');
    }
  }

  // -----------------------------------------------
  // 納期ラベル追記（組み合わせ考慮）
  // -----------------------------------------------
  function appendNoukiLabels() {
    const dataEl = document.getElementById('variant-nouki-data');
    if (!dataEl) return;

    let variantData;
    try { variantData = JSON.parse(dataEl.textContent); } catch(e) { return; }

    const selects = Array.from(document.querySelectorAll('select[data-variant-option]'));
    if (selects.length === 0) return;

    const selectedVals = selects.map(s => {
      if (!s.dataset.userSelected) return null;
      const opt = s.options[s.selectedIndex];
      return opt && opt.value ? opt.value : null;
    });

    const noneSelected = selectedVals.every(v => v === null);

    // 2軸以上で全て未選択はリセットして終了
    if (selects.length > 1 && noneSelected) {
      selects.forEach(select => {
        Array.from(select.options).forEach(opt => {
          if (!opt.value) return;
          const nouki = opt.getAttribute('data-nouki') || '';
          const suffix = nouki === '【在庫無し】次回未定' ? ' ×売り切れ' : '';
          opt.textContent = opt.value + suffix;
        });
      });
      return;
    }

    selects.forEach((select, idx) => {
      Array.from(select.options).forEach(opt => {
        if (!opt.value) return;

        const noukiSuffix = (opt.getAttribute('data-nouki') || '') === '【在庫無し】次回未定' ? ' ×売り切れ' : '';

        // このselectが選択済みかつ、他に未選択のselectがある場合はラベルなし
        const otherUnselected = selectedVals.some((v, i) => i !== idx && v === null);
        if (select.dataset.userSelected && selectedVals[idx] !== null && otherUnselected) {
          opt.textContent = opt.value + noukiSuffix;
          return;
        }

        const testVals = [...selectedVals];
        testVals[idx] = opt.value;

        const matched = variantData.filter(v =>
          testVals.every((val, i) => {
            if (val === null) return true;
            const key = i === 0 ? 'option1' : i === 1 ? 'option2' : 'option3';
            return v[key] === val;
          })
        );

        if (matched.length === 0) {
          opt.textContent = opt.value + noukiSuffix;
          return;
        }

        const worst = matched.reduce((prev, cur) =>
          getNoukiPriority(cur.nouki, cur.mark) > getNoukiPriority(prev.nouki, prev.mark) ? cur : prev
        );

        const label = getNoukiLabel(worst.nouki, worst.mark);
        opt.textContent = label ? opt.value + noukiSuffix + label : opt.value + noukiSuffix;
      });
    });
  }




  // -----------------------------------------------
  // イベント初期化
  // -----------------------------------------------
  function initSelectEvents() {
    const selects = document.querySelectorAll('select[data-variant-option]');
    selects.forEach(select => {
      if (select.dataset.barStyled) return;
      select.dataset.barStyled = 'true';
      select.addEventListener('change', function() {
        this.dataset.userSelected = 'true';
        updateAllSelectStyles();
        appendNoukiLabels();
      });
    });
    updateAllSelectStyles();
    appendNoukiLabels();
  }

  function init() {
    applyRadioStyles();
    initSelectEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // -----------------------------------------------
  // MutationObserver（無限ループ防止）
  // -----------------------------------------------
  let observerTimer = null;
  const observer = new MutationObserver(function() {
    if (observerTimer) return;
    observerTimer = setTimeout(function() {
      observer.disconnect();
      applyRadioStyles();
      initSelectEvents();
      updateAllSelectStyles();
      appendNoukiLabels();
      observer.observe(document.body, { childList: true, subtree: true });
      observerTimer = null;
    }, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
